import { ITab } from '../../types';
import { Tab } from '..';
import './style.scss';

interface IProps {
  tabs: ITab[];
}

function Tabs(props: IProps) {
  return (
    <div className='tabs-cntr-Las1'>
      <div className='tabs-container-8jsK'>
        {props.tabs.map((x) => (
          <Tab
            key={x.href}
            tab={x}
          />
        ))}
      </div>
    </div>
  );
}

export default Tabs;
